import { BaseModel } from "model/BaseModel";
import ItemClasseAuditoria from "./ItemClasseAuditoria";
import Arquivo from "model/arquivo/Arquivo";


export default class ComentarioAuditoria implements BaseModel {

    id: number;
    codigo: string | null;
    destaque: boolean;
    comentario: string;
    itemAuditoria: ItemClasseAuditoria;
    imagens: Arquivo[];

    constructor(
        id = 0,
        codigo = null,
        destaque = false,
        comentario = '',
        itemAuditoria = new ItemClasseAuditoria(),
        imagens = []
        
    ) {
        this.id = id;
        this.codigo = codigo;
        this.destaque = destaque;
        this.comentario = comentario;
        this.itemAuditoria = itemAuditoria;
        this.imagens = imagens;
    }
}